import { createSelector } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store";

const getSearchState = (state: AppState) => state.search;

export const getSearchLoading = createSelector(
  [getSearchState],
  (state) => state.loading,
);

export const getSearchData = createSelector([getSearchState], (state) => {
  const { article, brand, dispensary, menuItem, strain } = state;
  return { article, brand, dispensary, menuItem, strain };
});

export const getSearchMenuItemDispensaries = createSelector(
  [getSearchState],
  (state) => state.menuItemDispensaries,
);

export const getSearchCategoryRelevanceOrder = createSelector(
  [getSearchState],
  (state) => state.categoryRelevanceOrder,
);

export const getIsNullResult = createSelector(
  [getSearchData],
  (searchResults) => {
    const nullResults = Object.values(searchResults).filter(
      (result) => result.length,
    );
    return nullResults.length === 0;
  },
);

export const getTotalCounts = createSelector(
  [getSearchState],
  (state) => state.totalCounts,
);
